import { Box, Text } from '@jfs/ui-new'
import { FC, ReactElement } from 'react'
import { TableComponent } from '../../../comps/TableComponent'
import { MerchantType } from '../../../data/models/Merchant'
import { profileStrings } from '../../../data/static/strings'
import { useWindowDimensions } from '../../../util/util'
import { styles } from './../styles'

interface NotificationProps {
  hide?: boolean
  data: MerchantType
}

const notificationData = (email: string, number: string): any[] => {
  return [
    {
      id: '1',
      title: profileStrings.notificationMobileNum,
      value: number ? '+91' + number?.replace('91', '') : 'NA',
    },
    { id: '2', title: profileStrings.notificationEmailId, value: email ? email : 'NA' },
  ]
}

// const txnAlertsData = (settings: SettingsV2): any[] => {
//   return [
//     { id: '1', title: profileStrings.successTxns, value: settings?.notificationSettings[0]?.channel },
//     { id: '2', title: profileStrings.failTxnAlert, value: ['n', 'y', 'n'] },
//     { id: '3', title: profileStrings.chargeBackAlert, value: ['n', 'n', 'n'] },
//     { id: '4', title: profileStrings.downTimeNotAlert, value: ['n', 'n', 'n'] },
//     { id: '5', title: profileStrings.lowBalAlert, value: ['n', 'n', 'n'] },
//   ]
// }

// const merchantReportsData = [
//   { id: '1', title: profileStrings.txnRepGen, value: ['n', 'y', 'n'] },
//   { id: '2', title: profileStrings.refRepGen, value: ['n', 'n', 'n'] },
//   { id: '3', title: profileStrings.bulkRefRepGen, value: ['n', 'n', 'n'] },
//   { id: '4', title: profileStrings.setlmtRepGen, value: ['n', 'n', 'n'] },
//   { id: '5', title: profileStrings.profChange, value: ['n', 'n', 'n'] },
//   { id: '6', title: profileStrings.supTickUpdates, value: ['n', 'n', 'n'] },
//   { id: '7', title: profileStrings.userAcUpdates, value: ['n', 'n', 'n'] },
// ]
const Notification: FC<NotificationProps> = ({ hide, data }: NotificationProps) => {
  const viewPortWidth = useWindowDimensions()

  const themedStyle = styles(viewPortWidth)

  if (hide) {
    return null
  }

  const getSeperator = (): ReactElement => {
    return <Box {...themedStyle.separatorStyle} />
  }

  // const getHeader = (header: string): ReactElement => {
  //   return (
  //     <>
  //       <Box style={themedStyle.notificationHeaderStyle}>
  //         <Text style={themedStyle.headerTextStyle}>{header}</Text>
  //         <Box style={themedStyle.notificationRightContainer}>
  //           <Text style={themedStyle.notificationRightTextStyle}>{profileStrings.portal}</Text>
  //           <Text style={themedStyle.notificationRightTextStyle}>{profileStrings.email}</Text>
  //           <Text style={themedStyle.notificationRightTextStyle}>{profileStrings.sms}</Text>
  //         </Box>
  //       </Box>
  //       <Box style={themedStyle.separatorStyle} />
  //     </>
  //   )
  // }

  const renderListItem = ({ item }: any): ReactElement => {
    return (
      <Box {...themedStyle.listItemContainer}>
        <Text {...themedStyle.listItemKeyStyle} key={'key'}>
          {item?.title}
        </Text>
        <Text {...themedStyle.listItemValueStyle} testID={`notificationTabView-${item?.title?.replaceAll(' ', '')}`}>
          {item?.value}
        </Text>
      </Box>
    )
  }

  // const renderNotificationAlertListItem = ({ item }: any): ReactElement => {
  //   return (
  //     <Box style={themedStyle.listItemContainer}>
  //       <Text style={themedStyle.listItemKeyStyle}>{item?.title}</Text>
  //       <Box style={themedStyle.checkBoxsContainer}>
  //         <Checkbox
  //           isChecked={item?.value[0] === 'y'}
  //           type={CheckBoxTypes.DEFAULT}
  //           disabled={false}
  //           size={16}
  //           color={theme.grey.GREY_SHADE_1}
  //           onPress={(): void => null}
  //         />
  //         <Checkbox
  //           isChecked={item?.value[1] === 'y'}
  //           type={CheckBoxTypes.DEFAULT}
  //           disabled={false}
  //           color={theme.grey.GREY_SHADE_1}
  //           size={16}
  //           onPress={(): void => null}
  //         />
  //         <Checkbox
  //           isChecked={item?.value[2] === 'y'}
  //           type={CheckBoxTypes.DEFAULT}
  //           disabled={false}
  //           color={theme.grey.GREY_SHADE_1}
  //           size={16}
  //           onPress={(): void => null}
  //         />
  //       </Box>
  //     </Box>
  //   )
  // }
  return (
    <Box {...themedStyle.personalDataContainer}>
      <TableComponent
        value={''} //Routes value
        canFetchMore={false}
        ListContent={notificationData(data?.contact?.email ?? '', data?.contact?.mobile ?? '')}
        hide={false}
        isCustom={true}
        RenderCustomElement={renderListItem}
        ItemSeparatorComponent={getSeperator}
        keyExtractor={(item) => item.id}
      />
    </Box>
  )
}
export default Notification
